import { render } from "./CoreProcessSlaveComponent.vue?vue&type=template&id=257055bc&scoped=true"
import script from "./CoreProcessSlaveComponent.vue?vue&type=script&lang=js"
export * from "./CoreProcessSlaveComponent.vue?vue&type=script&lang=js"

import "./CoreProcessSlaveComponent.vue?vue&type=style&index=0&id=257055bc&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-257055bc"]])

export default __exports__